module.exports = __webpack_public_path__ + "img/ic-maestro-white.bc5062a1.svg";